const getSuccessMessageByPageType = (authorData = {}) => {
  let message = []
  if (authorData.selfRegistrationFormFlag) {
    message = ["Thank you for registering with us."]
  } else if (authorData.siteRegistrationFormFlag) {
    message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  } else if (authorData.bathroomInspirationFormFlag) {
    message = ["Thank you for registering."]
  } else if (
    authorData.warrantyRegistrationFormFlag
  ) {
    message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  } else if( authorData.omniChannelKECFormFlag){
    message = [
      "Appointment booked successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  }

  return message
}
const getSuccessMessageByPageTypeService = (authorData = {}) => {
  let message = [
      "Request received successfully.",
      "Our Kohler representative will reach out soon.",
    ]
  return message
}

const getParamsByURL = (omniQRParams = {}) => {
  const { placementType, placementId, qrId, kaspId } = omniQRParams

  if (placementType && placementId && qrId) {
    return {
      campaignId: placementType === "ServiceCamp" || placementType === "Service Camp" ? placementId : "",
      kecId: placementType === "Kec" ? placementId : "",
      eventId: placementType === "Event" ? placementId : "",
      dealerId: placementType === "Dealer" ? placementId : "",
      technicianId: placementType === "ServiceTechnician"|| placementType === "Service Technician" ? placementId : "",
      qrId,
      leadSubSourceSegment: placementType === "ServiceTechnician" || placementType === "Service Technician"?"Service Technician":placementType === "ServiceCamp"||placementType === "Service Camp"?"Service Camp":"Dealer",
      kaspId: kaspId
    }
  }
  return {
    dealerId: "",
    qrId: "",
    leadSubSourceSegment: "",
    campaignId:"",
    technicianId:"",
    kaspId:""
  }
}

const getPageParamsByType = authorData => {
  if (authorData.selfRegistrationFormFlag) {
    return {
      pageName: "selfregistration",
      pageNamePascalCase: "SelfRegistration",
      pagenamehyphen: "self-registration",
      pageTitle: "Self Registration",
      contentType: "selfregistration",
    }
  } else if (authorData.bathroomInspirationFormFlag) {
    return {
      pageName: "bathroominspiration",
      pageNamePascalCase: "BathroomInspiration",
      pagenamehyphen: "bathroom-inspiration",
      pageTitle: "Bathroom Inspiration",
      contentType: "inspiration",
    }
  } else if (authorData.omniChannelKECFormFlag) {
    return {
      pageName: "kecappointment",
      pageNamePascalCase: "KECAppointment",
      pagenamehyphen: "kec-appointment",
      pageTitle: "KEC Appointment",
      contentType: "appointment",
    }
  } else if (authorData.warrantyRegistrationFormFlag) {
    return {
      pageName: "warrantyregistration",
      pageNamePascalCase: "WarrantyRegistration",
      pagenamehyphen: "warranty-registration",
      pageTitle: "Warranty Registration",
      contentType: "warranty",
    }
  } else if (authorData.siteRegistrationFormFlag) {
    return {
      pageName: "sitevisit",
      pageNamePascalCase: "SiteVisit",
      pagenamehyphen: "site-visit",
      pageTitle: "Site Visit",
      contentType: "sitevisit",
    }
  } else if (authorData.amcFormFlag) {
    return {
      pageName: "amc",
      pageNamePascalCase: "AMC",
      pagenamehyphen: "amc",
      pageTitle: "AMC",
      contentType: "amc",
    }
  } else if (authorData.serviceRequestFormFlag) {
    return {
      pageName: "servicerequest",
      pageNamePascalCase: "ServiceRequest",
      pagenamehyphen: "service-request",
      pageTitle: "Service Request",
      contentType: "servicerequest",
    }
  }
}

const getEventInfoForOtp = authorData => {
  const pageURL = window.location.href
  const {
    pageName = "",
    pageTitle = "",
    contentType = "",
  } = getPageParamsByType(authorData)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `omnichannel:${pageName}:otpvalidation:success`,
    eventName: `omnichannel:${pageName}:otpvalidation:success`,
    eventStatus: "success",
    eventMsg: `User OTP validation successful for ${pageTitle}  form`,
    eventType: "form_interaction",
    internalLinkName: "otp validation",
    internalLinkPosition: `${pageTitle} Form`,
    internalLinkType: `retail:${contentType}:otp`,
    internalLinkZoneName: `${pageTitle} Section`,
    internalLinkURL: pageURL,
    selectRating: "",
    selectOption: "",
  }
  return eventInfo
}

const getFormInfoForOtp = (data, authorData) => {
  const { firstName = "", lastName = "", mobileNumber = "" } = data || {}
  const { pageTitle = "" } = getPageParamsByType(authorData)
  return {
    form: {
      formName: "Lead Creation",
      formType: `Retail / ${pageTitle}`,
      formStatus: "otp_validated",
      formValues: {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: mobileNumber,
      },
    },
  }
}

const getEventInfoFormSubmit = (authorData, resultType, omnichannelFormId) => {
  const pageURL = window.location.href
  let { pageNamePascalCase, pageTitle, contentType } =
    getPageParamsByType(authorData)
  if (omnichannelFormId) {
    pageNamePascalCase = omnichannelFormId.toLowerCase()
    pageTitle = omnichannelFormId
    contentType = omnichannelFormId.toLowerCase()
  }
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `omnichannel:landing:${pageNamePascalCase}:${resultType}`,
    eventName: `omnichannel:landing:${pageNamePascalCase}:${resultType}`,
    eventStatus: `${resultType}`,
    eventMsg: `Retail customer navigated to ${pageTitle} page`,
    eventType: "navigation",
    internalLinkName: `${pageTitle}`,
    internalLinkPosition: `Omnichannel Landing Page`,
    internalLinkType: `retail:${contentType}`,
    internalLinkZoneName: `${pageTitle} Section`,
    internalLinkURL: pageURL,
    selectRating: "",
    selectOption: "",
  }
  return eventInfo
}

const getEventInfoFormFilled = (authorData, omnichannelFormId) => {
  let { pageNamePascalCase } = getPageParamsByType(authorData)
  if (omnichannelFormId) {
    pageNamePascalCase = omnichannelFormId.toLowerCase()
  }
  const eventInfo = {
    clickInternalLinks: "true",
    internalLinkPosition: `kohler-india:${pageNamePascalCase} : Form`,
    internalLinkZoneName: `kohler-india:${pageNamePascalCase}`,
    internalLinkURL: "n/a",
    internalLinkName: "success",
    eventName: `kohler-india:${pageNamePascalCase}:form step1`,
    internalLinkType: "Form Submission",
    eventType: "Form",
    eventAction: `kohler-india:${pageNamePascalCase}:Form Fill Complete`,
  }
  return eventInfo
}

const getEventInfoRecaptcha = (isSuccess, authorData, omnichannelFormId) => {
  let { pageNamePascalCase } = getPageParamsByType(authorData)
  if (omnichannelFormId) {
    pageNamePascalCase = omnichannelFormId.toLowerCase()
  }
  const eventInfo = {
    clickInternalLinks: "true",
    internalLinkPosition: `kohler-india:${pageNamePascalCase} : Form`,
    internalLinkZoneName: `kohler-india:${pageNamePascalCase}`,
    internalLinkURL: "n/a",
    internalLinkName: `${isSuccess ? "success" : "failure"}`,
    eventName: `kohler-india:${pageNamePascalCase}:form step2`,
    internalLinkType: "Form Submission",
    eventType: "Form",
    eventAction: `kohler-india:${pageNamePascalCase}:Form Captcha ${
      isSuccess ? "Complete" : "Failed"
    }`,
  }
  return eventInfo
}

const getFormInfoForSubmittion = (
  data = {},
  authorData = {},
  paramsByUrl = {},
  omnichannelFormId
) => {
  let { pageTitle } = getPageParamsByType(authorData)
  if (omnichannelFormId) {
    pageTitle = omnichannelFormId.toLowerCase()
  }
  const {
    firstName,
    lastName,
    mobileNumber,
    email,
    pinCode,
    noOfBathroom,
    budget,
    purchasePick,
    whatsAppConsent,
    smsAppConsent,
    productCategory = "",
    siteAddress = "",
    productImages = [],
    fileType = "",
    state = "",
    city = "",
    kecCity = "",
  } = data
  const { campaignId, kecId, eventId, dealerId, qrId } = paramsByUrl
  return {
    form: {
      formName: "Lead Creation",
      formType: `Retail / ${pageTitle}`,
      formStatus: "initiated",
      formValues: {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: mobileNumber,
        email: email,
        pincode: pinCode,
        noOfBathrooms: noOfBathroom,
        budget: budget,
        expectedPurchase: purchasePick,
        whatsappOptIn: whatsAppConsent,
        otherOptIn: smsAppConsent,
        segment: "Retail",
        productCategory: productCategory,
        address: siteAddress,
        qrId: qrId,
        campaignId: campaignId,
        kecId: kecId,
        kecCity: kecCity,
        state: state,
        city: city,
        eventId: eventId,
        dealerId: dealerId,
        scanEventType: pageTitle,
        leadSubSourceSegment: "Omnichannel",
        leadType: "Retail",
        leadSource: "Omnichannel Landing",
        leadSubSource: pageTitle,
        leadStatus: "New",
        leadCurrency: "INR",
        appointment: {
          dateTime: "",
          slot: "",
          status: "",
          capacity: "",
        },
        warranty: {
          uploadFileType: fileType,
          source: productImages.length > 0 ? productImages[0] : "",
        },
        siteVisit: {
          symptom: "",
          callerNumber: "",
          callerType: "",
          callAllocationType: "",
        },
      },
    },
  }
}

const kecCityMapping = [
  { Bangalore: "KEC Bangalore" },
  { Delhi: "KEC Delhi" },
  { Mumbai: "KEC Mumbai" },
  { Ahmedabad: "Studio Ahmedabad" },
  { Hyderabad: "Studio Hyderabad" },
  { Chennai: "Studio Chennai" },
  { Pune: "Studio Pune" },
]

const getOmniCTAEventInfo = (pageTitle = "", buttonName = "") => {
  return {
    clickInternalLinks: "true",
    internalLinkPosition: `kohler-india:${pageTitle}`,
    internalLinkZoneName: `kohler-india:${pageTitle}`,
    internalLinkURL: `${window.location.href}`,
    internalLinkName: buttonName,
    eventName: `kohler-india:${pageTitle}:${buttonName}`,
    internalLinkType: "Other",
    eventType: "Button",
    eventAction: `kohler-india:${pageTitle}:${buttonName}`,
  }
}
const sessionStoreClosure = () => {
  let userDetailsRef = {
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    pinCode: '',
    city: '',
    state: ''
  }
  const acceptedAttributes = Object.keys(userDetailsRef)
  const filterAcceptedFormData = (_obj) =>{
    return Object.fromEntries(Object.entries(_obj).filter(([key]) => acceptedAttributes.includes(key)))
  }
  const addSessionUserDetails = function (qrId, formObj) {
    const filteredFormObj = filterAcceptedFormData(formObj)
    window.sessionStorage.setItem(`${qrId}`,JSON.stringify({...filteredFormObj}))
  }
  const getSessionUserDetails = function (qrId) {
    if(!qrId){
      return {}
    }
    let localStorage_userdata = JSON.parse(window.sessionStorage.getItem(qrId))
    if(localStorage_userdata){
      return {...localStorage_userdata}
    }else{
      return userDetailsRef
    }
  }
  return {
    addSessionUserDetails,
    getSessionUserDetails
  }
}

const { addSessionUserDetails, getSessionUserDetails } = sessionStoreClosure()

const getInitialDataValues = function (paramsByUrl) {
    const {
      qrId
    } = paramsByUrl
  const _session_userDetails = getSessionUserDetails(qrId)
  return {
    ..._session_userDetails,
    noOfBathroom: "",
    budget: "",
    whatsAppConsent: true,
    smsAppConsent: true,
    kecCity: "",
    purchasePick: "",
    productCategory: "",
    constructionType: "",
    siteAddress: "",
    customerImage: [],
    uploadedImage: [],
    reportIssue: "",
    alternateMobileNumber:"",
    landmark:"",
    slot:"",
    appointmentDate:""
  }
}

const verifyRecaptchaToken = async token => {
  if (!token) return false

  try {
    const response = await fetch("/api/verify-recaptcha", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ token }),
    })

    const data = await response.json()
    return data.success
  } catch (error) {
    console.error("Recaptcha verification failed:", error)
    return false
  }
}
const placementIdArray = [
  "0015j000008BUEhAAO",
  "001e1000001uMyGAAU",
  "0015j000008BVcfAAG",
  "0015j00000tdjPGAAY",
  "0015j000012TBjAAAW",
  "0015j00000reXnyAAE",
  "0015j000008BVfWAAW",
  "0015j000008BU6yAAG",
  "0015j000008BU21AAG",
  "0015j00000uBWfMAAW",
  "0015j00000ucXDqAAM",
  "0015j00001Bn8pJAAR",
  "0015j000008BUF0AAO",
  "0015j00000ZqVf5AAF",
  "0015j00000UDCfTAAX",
  "0015j000008BVS1AAO",
  "0015j000008BVRwAAO",
  "0015j000008BVgkAAG",
  "0015j000008BVpxAAG",
  "0015j000008BV0rAAG",
  "0015j000008BJA9AAO",
  "0015j000008BVq4AAG",
  "0015j000008BTgJAAW",
  "001J400000S9Yn4IAF",
  "001J400000VxGxIIAV",
  "0015j000008BVQBAA4",
  "0015j00000qwuzOAAQ",
  "0015j000008BJc0AAG",
  "0015j000008BSJzAAO",
  "0015j00001EIo8gAAD",
  "001fv00000CLat7AAD",
  "0015j000008BVg6AAG",
  "0015j000008BVKnAAO",
  "0015j00000g85MzAAI",
  "001J400000LcHEdIAN",
]
const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
export const recaptchaError = "/kdx/recaptcha-error"

export {
  getSuccessMessageByPageType,
  getSuccessMessageByPageTypeService,
  getEventInfoForOtp,
  getFormInfoForOtp,
  getEventInfoFormSubmit,
  getFormInfoForSubmittion,
  getParamsByURL,
  kecCityMapping,
  getOmniCTAEventInfo,
  getInitialDataValues,
  sessionStoreClosure,
  addSessionUserDetails,
  getSessionUserDetails,
  placementIdArray,
  verifyRecaptchaToken,
  recaptchaSiteKey,
  getEventInfoFormFilled,
  getEventInfoRecaptcha,
}
